import { Directive, ElementRef, Renderer2, Input, OnInit } from '@angular/core';
import { NgControl, AbstractControl } from '@angular/forms';

@Directive({
  selector: 'select[placeholder]',
})
export class SelectPlaceholderDirective implements OnInit {
  private _elem: HTMLSelectElement;
  private _formControl: NgControl;

  @Input() placeholder: string;

  constructor(formControl: NgControl, elem: ElementRef, private renderer: Renderer2) {
    this._elem = elem.nativeElement;
    this._formControl = formControl;
  }

  ngOnInit() {
    setTimeout(() => {
      const defaultOpt = this.renderer.createElement('option');
      defaultOpt.text = this.placeholder;
      defaultOpt.value = null;
      this.renderer.insertBefore(this._elem, defaultOpt, this._elem.firstChild);
    }, 0);
  }
}
